// removed by extract-text-webpack-plugin
module.exports = {"Beers":"Beers__Beers__-hash-base-64-5-","Spinner":"Beers__Spinner__-hash-base-64-5-","EndLine":"Beers__EndLine__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/Beers/Beers.scss
// module id = 179
// module chunks = 0